import React, { useMemo } from 'react';
import { PublicLayout } from '../../../components/layout/layout';
import { TranslatedBreadcrumbs } from '../../../components/translated-breadcrumbs';
import { useNavigation } from '@refinedev/core';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { tabulate } from '../../../components/specification/utils/tabulate';
import { cards } from '../../../components/specification/data/cards';
import styles from './show.module.scss';
import { Show } from '@refinedev/antd';

export interface ISpecification {
    id?: string;
    title?: string;
    href?: string;
    body?: any[];
}

export interface ISpecificationItem {
    label?: string | JSX.Element | undefined;
    value?: string | JSX.Element | undefined;
}

export type Specification = ISpecification | undefined;

const SpecShow = () => {
    const { replace } = useNavigation();
    const { query } = useParams();
    const { t } = useTranslation();

    const found: Specification = useMemo(
        () =>
            cards.find(
                (card: { id: string | undefined }) => card?.id === query
            ),
        [query]
    );

    return (
        <PublicLayout>
            <Show
                headerProps={{
                    breadcrumb: <TranslatedBreadcrumbs />,
                    extra: null,
                    title: t('specs.specs'),
                    onBack: () => replace('/specs'),
                }}
            >
                <div className={styles.showTable}>
                    <div className={styles.pageHeading}>
                        <span>{t(`${found?.title}`)}</span>
                    </div>
                    <div className={styles.pageContent}>
                        {tabulate(found?.body, t)}
                    </div>
                </div>
            </Show>
        </PublicLayout>
    );
};

export default SpecShow;
